$(document).ready(function(){
  			if($('h1').length>1)
            {
  			let i=1,str;
  			$('h1').each(function(){
  			if(i>1)
    			{
  			str=$(this).text();
        			$(this).replaceWith(`<h2>${str}</h2>`);
    			}
    			i++;        
			});
            }
  setTimeout(function(){ $('.wsaio_form').text('Create Trade Account'); }, 100);
});

jQuery(function() {
    $('.variant-wrapper .variant-input-wrap input[type="radio"]').click(function() {
        setTimeout(function(){ 
      		$(".Variant-refresh").load("#Texts-AfterCart .free-shipping-cta .Variant-refresh");
        }, 1);
    });
    $('.Product-Variant-Dropdown').change(function(){
        setTimeout(function(){ 
      		$(".Variant-refresh").load("#Texts-AfterCart .free-shipping-cta .Variant-refresh");
        }, 1);
      	console.log('change variant');
    });
});

